import { createContext, FC, ReactNode, useContext } from 'react';

// Whether a merchant theme is configured for the invoice.
//
// This is intentionally distinct from "the theme has any non-empty values": a
// theme can be configured while all of its fields are empty, and we must still
// treat it as configured. Consumers (e.g. the invoice logo) use this to decide
// whether to honor the theme's values — even empty ones — instead of falling
// back to the invoice's own defaults. Defaults to `false` (no theme) so callers
// outside a provider behave as un-themed.
const ThemeConfiguredContext = createContext<boolean>(false);

interface ThemeConfiguredProviderProps {
  value: boolean;
  children: ReactNode;
}

export const ThemeConfiguredProvider: FC<ThemeConfiguredProviderProps> = ({ value, children }) => (
  <ThemeConfiguredContext.Provider value={value}>{children}</ThemeConfiguredContext.Provider>
);

export const useThemeConfigured = (): boolean => useContext(ThemeConfiguredContext);
